import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { CTABanner } from "@/components/site/CTABanner";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";

const FAQ = () => (
  <>
    <Seo
      title="FAQ | Cleaning Services Questions Answered | Oz SpotNest Sydney"
      description="Answers to common questions about our cleaning services — service areas, regular & one-off cleaning, bond cleaning, Airbnb turnovers, office & strata cleaning, NDIS & aged care support and pricing."
    />
    <PageHero
      eyebrow="FAQ"
      title="Questions,"
      highlight="Answered"
      description="Everything you need to know about booking a clean with Oz SpotNest. Can't find your answer? Call us — we're happy to help."
    />
    <section className="section-pad" data-testid="faq-section">
      <div className="container-site max-w-4xl">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-slate-200">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="text-left font-heading text-base font-semibold text-navy-800 hover:text-emerald-600 hover:no-underline sm:text-lg"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-600 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-14 rounded-3xl border border-slate-100 bg-slate-50 p-8 text-center sm:p-10">
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">Still have a question?</h2>
            <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed sm:text-base">
              The fastest way to get an answer is to request a free quote or give us a call.
            </p>
            <Link to="/contact" data-testid="faq-quote-button" className="btn-primary mt-7 group">
              Request a Free Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
    <CTABanner />
  </>
);

export default FAQ;
